import { gql } from '@/__generated__';

export const GET_VISIBLE_UNITS = gql(`#graphql
  query GetVisibleUnits($input: UserInput) {
    user(input: $input) {
      id
      preferences {
        id
        visibleUnits
      }
    }
  }
`);
